import { PublicClientApplication } from '@azure/msal-browser'

import { loginRequest, msalConfig } from 'config/authentication.config'

interface TokenAcquireResultType {
    expires_On: Date | null
    access_token: string
}

const getAuthToken = async (clearAndRetryOnFailure = true): Promise<TokenAcquireResultType | null> => {
    const msalInstance = new PublicClientApplication(msalConfig)
    const [account] = msalInstance.getAllAccounts()

    try {
        if (!account) {
            window.location.href = `${window.location.origin}/login`
            return null
        }

        const response = await msalInstance.acquireTokenSilent({
            scopes: loginRequest.scopes,
            account,
        })
        if (response) {
            return { expires_On: response.expiresOn, access_token: response.accessToken }
        }
    } catch (e) {
        if (clearAndRetryOnFailure) {
            Object.keys(localStorage).forEach((key) => {
                if (key !== 'i18nextLng') {
                    localStorage.removeItem(key)
                }
            })
            return getAuthToken(false)
        }
    }
    return null
}

export default getAuthToken
